import { Configuration } from "@devour/client";

// Set the global base path for all API calls
if (!import.meta.env.VITE_BACKEND_REST_URL) {
    throw new Error("VITE_BACKEND_REST_URL environment variable is not set. Please check your .env file.");
}
Configuration.BASE_PATH = import.meta.env.VITE_BACKEND_REST_URL;


// Export a function to get powerful API config
export function getPowerfulApiConfig(): Partial<Configuration> {
    if (!import.meta.env.VITE_BACKEND_REST_POWERFUL_URL) {
        throw new Error("VITE_BACKEND_REST_POWERFUL_URL environment variable is not set. Please check your .env file.");
    }
    return {
        basePath: import.meta.env.VITE_BACKEND_REST_POWERFUL_URL,
    };
}